import React from 'react';
import logo from './logo.png';
import './App.css';
import SubmitForm from './components/SubmitForm';
import SiteInfo from './components/SiteInfo';
import ExemptionService from './services/ExemptionService';
import SiteService from './services/SiteService';
import NotFound from './components/NotFound';

export default class App extends React.Component {

  excemptionService = new ExemptionService();
  siteService = new SiteService();

  constructor(props) {
    super(props);

    this.state = {
      qrCode: window.location.pathname.substring(1),
      timer: Number.parseFloat(new URL(window.location.href).searchParams.get('refresh')),

      notFound: false,
      formSubmitted: false,

      site: null,
      siteInfo: null,
      pdfComp: null,
      result: null,

      showTick: false
    }
  }

  componentDidMount() {
    if (!this.site?.name && this.state.qrCode) {
      this.siteService.getSiteDetails(this.state.qrCode).then(s => {
        if (s.success) {
          this.setState({ site: s, siteInfo: <SiteInfo name={s.name} /> });
        } else {
          this.setState({ notFound: true });
        }
      });
    } else {
      this.setState({ notFound: true });
    }
  }

  render() {
    return this.renderForm();
  }

  renderForm() {
    // Render not found message if we don't recognise the site or it is blank.
    if (this.state.notFound) {
      return (
        <div className="App">
          <img src={logo} className="App-logo" alt="logo" width="256" />
          <div className="App-main" id="main">
            <NotFound />
          </div>
        </div>
      );
    }

    if (this.state.site?.name && !this.state.formSubmitted) {
      // Site has loaded, render form.
      return (
        <div className="App">
          <img src={logo} className="App-logo" alt="logo" width="256" />
          <div className="App-main" id="main">
            {this.state.siteInfo}
            <SubmitForm allowDynamicExemptionDuration={this.state.site.allowDynamicExemptionDuration} exemptionDuration={this.state.site.exemptionDuration}
              exemptionDurationType={this.state.site.exemptionDurationType} onSubmitRegistration={(value) => this.submitRegistration(value)} />
          </div>
        </div>
      );
    } else if (this.state.formSubmitted) {
      return (
        <div className="App">
          <img src={logo} className="App-logo" alt="logo" width="256" />
          <div className="App-main" id="main">
            <div className='icon'>
              {this.state.result?.success ? this.drawSuccessIcon() : this.drawFailIcon()}
            </div>
            {this.state.pdfComp}
            {this.state.result?.message && this.state.result.message.split('\n').map((line, i) => <p dangerouslySetInnerHTML={{ __html: line }}></p>)}
          </div>
        </div>
      );
    }
    else {
      // We're in a loading state, display empty component for now.
      return <p></p>;
    }
  }

  drawSuccessIcon() {
    return (
      <svg className={'checkmark' + (this.state.showTick ? ' drawn' : '')} version='1.1' id='tick' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px'
        viewBox='0 0 37 37' xmlSpace='preserve'>
        <path className='circ path' d='M30.5,6.5L30.5,6.5c6.6,6.6,6.6,17.4,0,24l0,0c-6.6,6.6-17.4,6.6-24,0l0,0c-6.6-6.6-6.6-17.4,0-24l0,0C13.1-0.2,23.9-0.2,30.5,6.5z'
        />
        <polyline className='tick path' points='11.6,20 15.9,24.2 26.4,13.8' />
      </svg>
    );
  }

  drawFailIcon() {
    return (
      <svg className={'checkmark fail' + (this.state.showTick ? ' drawn' : '')} version='1.1' id='tick' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px'
        viewBox='0 0 37 37' xmlSpace='preserve'>
        <path className='circ path' d='M30.5,6.5L30.5,6.5c6.6,6.6,6.6,17.4,0,24l0,0c-6.6,6.6-17.4,6.6-24,0l0,0c-6.6-6.6-6.6-17.4,0-24l0,0C13.1-0.2,23.9-0.2,30.5,6.5z'
        />
        <polyline className="tick path" points='12.78181818,12.78181818 24.21818182,24.21818182' />
        <polyline className="tick path" points='24.21818182,12.78181818 12.78181818,24.21818182' />
      </svg>
    );
  }

  submitRegistration(value) {
    this.excemptionService.requestExemption(value.registration, this.state.qrCode, value.recaptchaResponse, value.exemptionDuration).then(r => {
      this.setState({ formSubmitted: true, result: r });

      requestAnimationFrame(() => {
        this.setState({ showTick: true });

        // If we have a timer, refresh the page after the timer has expired.
        if (this.state.timer)
          setTimeout(() => {
            window.location.reload();
          }, this.state.timer * 1000);
      });
    });
  }
}